// src/utils/tikTokPixel.js
/**
 * Utility functions for TikTok Pixel event tracking.
 * Provides a safe wrapper around ttq.track() calls for React SPA usage.
 *
 * Standard Events Documentation:
 * https://ads.tiktok.com/help/article/standard-events-parameters
 */

/**
 * Safely tracks a TikTok Pixel event.
 * Handles cases where the pixel hasn't loaded yet.
 *
 * @param {string} eventName - TikTok standard or custom event name
 * @param {Object} [parameters] - Optional event parameters
 * @returns {boolean} - True if event was tracked, false if ttq not available
 */
export function trackTikTokEvent(eventName, parameters = {}) {
  try {
    if (typeof window !== 'undefined' && window.ttq && typeof window.ttq.track === 'function') {
      if (Object.keys(parameters).length > 0) {
        window.ttq.track(eventName, parameters);
      } else {
        window.ttq.track(eventName);
      }
      console.log(`[TikTokPixel] Tracked event: ${eventName}`, parameters);
      return true;
    } else {
      console.warn(`[TikTokPixel] ttq not available, could not track: ${eventName}`);
      return false;
    }
  } catch (error) {
    console.error(`[TikTokPixel] Error tracking event ${eventName}:`, error);
    return false;
  }
}

/**
 * Tracks a Contact event in TikTok Pixel.
 * Used for all conversion actions: phone/email submissions and contact button clicks.
 * The content_id identifies which specific trigger fired the event.
 *
 * @param {string} contentId - Identifier for the trigger source (e.g. 'onboarding_phone', 'view_report_contact')
 * @returns {boolean}
 */
export function trackTikTokContact(contentId) {
  return trackTikTokEvent('Contact', {
    contents: [
      {
        content_id: contentId,
        content_type: 'product',
      },
    ],
  });
}

export default {
  trackTikTokEvent,
  trackTikTokContact,
};
